import { render, staticRenderFns } from "./DadosTerminal.vue?vue&type=template&id=8b0dca4a"
import script from "./DadosTerminal.vue?vue&type=script&lang=js"
export * from "./DadosTerminal.vue?vue&type=script&lang=js"
import style0 from "./DadosTerminal.vue?vue&type=style&index=0&id=8b0dca4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports